module.exports = __webpack_public_path__ + "static/media/empty-messages.5716de0d.png";